<div class="container-fluid">
  <div class="col-xs-12">
    <ng-container *ngIf="tenantUsesPsc">
      <div class="row" *ngIf="(permissions.canRead(permissions.ComponentID.HumanResources))">

        <h3><strong>Service Dashboard:</strong> </h3>

        <div class="row">
          <aims-common-button aria-label="Request Personnel Status Change (PSC)" (click)="selfServicePsc()">
            <mat-icon>add</mat-icon>
            Request Personnel Status Change (PSC)
          </aims-common-button>
        </div>
        <div class="row">
          <aims-common-table id="ssPscs-table" [label]="ssTableLabel" [dataSource]="ssPscs | async" [header]="header"
            [permissions]="tablePermissions" [pageSize]="5">

            <aims-common-table-dynamic-row id="pscTypeId">
              <ng-template viewMode let-element let-dynamicControl="dynamicControl"> {{ element.pscTypeId |
                getText:'pscTypeId':'pscType':ssPscTypeValues | async}}</ng-template>
            </aims-common-table-dynamic-row>
          </aims-common-table>

        </div>
      </div>
      <br>
      <div class="row" *ngIf="(permissions.canRead(permissions.ComponentID.PscDmApprovalQueue))">

        <h3><strong>DM Self Service:</strong></h3>

        <div class="row">
          <mat-label>Select Employee: </mat-label>
        </div>
        <div class="row">
          <mat-form-field appearance="fill">
            <mat-select #aimsControl="ngModel" [(ngModel)]="employeeId" name="Select Employee"
              (selectionChange)="dmSelfServicePsc(employeeId)" required>
              <mat-option *ngFor="let e of myDeptEmployees | async" [value]="e.employeeId">
                {{ e.fullName}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="row">
          <aims-common-table id="dmPscs-table" [label]="dmTableLabel" [dataSource]="dmPscs | async" [header]="header"
            [permissions]="tablePermissions" [pageSize]="5">

            <aims-common-table-dynamic-row id="pscTypeId">
              <ng-template viewMode let-element let-dynamicControl="dynamicControl"> {{ element.pscTypeId |
                getText:'pscTypeId':'pscType':dmPscTypeValues | async}}</ng-template>
            </aims-common-table-dynamic-row>
          </aims-common-table>
        </div>
      </div>

    </ng-container>
  </div>
</div>